import { useEffect, useRef, useState } from "react";

/** Flash duration after a queue number changes (ms). */
export const QUEUE_FLASH_MS = 3000;

/**
 * True for QUEUE_FLASH_MS after `value` changes (not on first render).
 * Used to pull attention to a card / number when the served token moves.
 */
export function useQueueFlash(value: number | string): boolean {
  const prev = useRef(value);
  const [flashing, setFlashing] = useState(false);

  useEffect(() => {
    if (prev.current === value) return;
    prev.current = value;
    setFlashing(true);
    const id = window.setTimeout(() => setFlashing(false), QUEUE_FLASH_MS);
    return () => window.clearTimeout(id);
  }, [value]);

  return flashing;
}
